import React, { useState, useEffect, useRef } from 'react';

const CodeEditor = ({ value, onChange, language = 'html', placeholder = 'Введите код...' }) => {
  const [content, setContent] = useState(value || '');
  const textareaRef = useRef(null);
  const lineNumbersRef = useRef(null);

  useEffect(() => {
    setContent(value || '');
  }, [value]);

  const handleChange = (e) => {
    const newContent = e.target.value;
    setContent(newContent);
    onChange(newContent);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      const start = e.target.selectionStart;
      const end = e.target.selectionEnd;
      const newContent = content.substring(0, start) + '  ' + content.substring(end);
      setContent(newContent);
      onChange(newContent);

      // Устанавливаем курсор после табуляции
      setTimeout(() => {
        e.target.selectionStart = e.target.selectionEnd = start + 2;
      }, 0);
    }
  };

  const getLineNumbers = () => {
    const lines = content.split('\n');
    return lines.map((_, index) => index + 1).join('\n');
  };

  const getLanguageClass = () => {
    switch (language) {
      case 'html': return 'language-html';
      case 'css': return 'language-css';
      case 'javascript': return 'language-javascript';
      default: return 'language-html';
    }
  };

  return (
    <div className="code-editor-container">
      <div className="code-editor-header">
        <span className="language-badge">{language.toUpperCase()}</span>
        <div className="editor-actions">
          <button
            type="button"
            className="btn-clear"
            onClick={() => {
              setContent('');
              onChange('');
            }}
            title="Очистить"
          >
            🗑️
          </button>
        </div>
      </div>
      <div className="code-editor-wrapper">
        <div className="line-numbers" ref={lineNumbersRef}>
          <pre>{getLineNumbers()}</pre>
        </div>
        <textarea
          ref={textareaRef}
          className={`code-textarea ${getLanguageClass()}`}
          value={content}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          spellCheck={false}
        />
      </div>
    </div>
  );
};

export default CodeEditor;
